if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        // Prefer the dedicated button-text span so we don't overwrite price span
        this.submitButtonText = this.submitButton.querySelector('.button-text') || this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Mobile fix: Ensure variant ID is properly set before submission
        const variantIdInput = this.variantIdInput;

        // CRITICAL FIX: Calculate correct variant ID from selected options
        function findCorrectVariantId() {
          // Get all selected option values
          const selectedOptions = [];

          // Check radio buttons
          const radioInputs = document.querySelectorAll('input[type="radio"]:checked[name*="options"]');
          radioInputs.forEach(radio => {
            if (radio.dataset.optionValueId) {
              selectedOptions.push(radio.dataset.optionValueId);
            }
          });

          // Check select dropdowns
          const selectInputs = document.querySelectorAll('select[name*="options"]');
          selectInputs.forEach(select => {
            const selectedOption = select.options[select.selectedIndex];
            if (selectedOption && selectedOption.dataset.optionValueId) {
              selectedOptions.push(selectedOption.dataset.optionValueId);
            }
          });

          // Try to find the matching variant from the product variants
          if (window.productVariants && Array.isArray(window.productVariants)) {
            for (const variant of window.productVariants) {
              if (variant.option_values && Array.isArray(variant.option_values)) {
                const variantOptionIds = variant.option_values.map(opt => opt.id.toString());

                // Check if selected options match this variant
                const optionsMatch = selectedOptions.length === variantOptionIds.length &&
                  selectedOptions.every(id => variantOptionIds.includes(id));

                if (optionsMatch) {
                  return variant.id;
                }
              }
            }
          }

          // Fallback: check data-selected-variant element
          const selectedVariantElement = document.querySelector('[data-selected-variant]');
          if (selectedVariantElement && selectedVariantElement.innerHTML) {
            try {
              const variantData = JSON.parse(selectedVariantElement.innerHTML);
              if (variantData && variantData.id) {
                return variantData.id;
              }
            } catch (e) {
              // Malformed variant JSON; fall through to return null below.
            }
          }

          return null;
        }

        // MOBILE CRITICAL FIX: If no variant ID but variant is selected visually, try to find it
        if (!variantIdInput || !variantIdInput.value || variantIdInput.value === '') {
          const correctVariantId = findCorrectVariantId();
          if (correctVariantId && variantIdInput) {
            variantIdInput.value = correctVariantId;
          } else {
            this.handleErrorMessage('Please select a product variant');
            return;
          }
        } else {
          // CRITICAL: Even if variant ID exists, validate it matches the selected options
          const currentVariantId = parseInt(variantIdInput.value);
          const correctVariantId = findCorrectVariantId();

          if (correctVariantId && currentVariantId !== correctVariantId) {
            // Update to the correct variant ID
            variantIdInput.value = correctVariantId;
          }
        }
        // Mobile fix: Ensure quantity is synced properly
        const customQuantityInput = document.querySelector('#quantity');
        const shopifyQuantityInput = this.form.querySelector('input[name="quantity"]');
        if (customQuantityInput && shopifyQuantityInput) {
          const customQuantity = parseInt(customQuantityInput.value) || 1;
          shopifyQuantityInput.value = customQuantity;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Mobile fix: Validate form data before submission
        const variantId = formData.get('id');
        const quantity = formData.get('quantity');

        if (!variantId || variantId === '' || variantId === 'null') {
          this.handleErrorMessage('Please select a product variant before adding to cart');
          this.submitButton.setAttribute('aria-disabled', false);
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner').classList.add('hidden');
          return;
        }

        if (!quantity || parseInt(quantity) < 1) {
          formData.set('quantity', '1');
        }

        // Always include essential cart sections
        let sectionsToRender = ['cart-icon-bubble'];

        if (this.cart) {
          sectionsToRender = sectionsToRender.concat(
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // Also include cart-popup section if cart popup exists
        const cartPopup = document.querySelector('.cart-popup');
        if (cartPopup) {
          sectionsToRender.push('cart-popup');
        }

        // Remove duplicates
        sectionsToRender = [...new Set(sectionsToRender)];

        formData.append('sections', sectionsToRender);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);

                // Manually update cart icon bubble and cart popup if they exist
                this.updateCartElements(response);

                // Dispatch event for cart header update
                document.dispatchEvent(new CustomEvent('cart:item-added', {
                  detail: response
                }));
              });
            this.error = false;

            // Add product-added class to this product-form element
            this.classList.add('product-added');

            // Note: No need to sync with moved buy buttons since they're no longer duplicated

            // Change button text to "Added"
            if (this.submitButtonText) {
              this.submitButtonText.textContent = window.variantStrings?.addedToCart || 'Added';
            }

            // Reset quantity inputs to 1 after successful cart addition
            const customQuantityInput = document.querySelector('#quantity');
            const shopifyQuantityInput = this.form.querySelector('input[name="quantity"]');

            if (customQuantityInput) {
              customQuantityInput.value = 1;
              // Trigger input event to sync with other inputs and update price
              customQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
            }
            if (shopifyQuantityInput) {
              shopifyQuantityInput.value = 1;
            }

            // Trigger the button price update if the function exists
            if (window.updateButtonPrice && typeof window.updateButtonPrice === 'function') {
              window.updateButtonPrice();
            } else {
              // Alternative: dispatch a custom event that the product page can listen for
              document.dispatchEvent(new CustomEvent('quantity:reset', {
                detail: { quantity: 1 }
              }));
            }

            // Remove the class after 3 seconds
            setTimeout(() => {
              this.classList.remove('product-added');

              // Note: No need to sync with moved buy buttons since they're no longer duplicated

              if (this.submitButtonText) {
                this.submitButtonText.textContent = window.variantStrings?.addToCart || 'Add to Cart';
              }
            }, 3000);
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch(() => {
            // Add-to-cart failed; UI state is restored in finally().
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      updateCartElements(response) {
        // Update cart icon bubble
        if (response.sections && response.sections['cart-icon-bubble']) {
          const cartIconBubble = document.getElementById('cart-icon-bubble');
          if (cartIconBubble) {
            cartIconBubble.innerHTML = this.getSectionInnerHTML(response.sections['cart-icon-bubble']);
          }
        }

        // Update cart popup content if it exists
        if (response.sections && response.sections['cart-popup']) {
          const html = new DOMParser().parseFromString(response.sections['cart-popup'], 'text/html');

          // Replace the entire cart-popup-inner to avoid any duplication
          const targetInner = document.querySelector('.cart-popup-inner');
          const sourceInner = html.querySelector('.cart-popup-inner');
          if (targetInner && sourceInner) {
            targetInner.innerHTML = sourceInner.innerHTML;
          }
        }
      }

      getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
      }
    }
  );
}
